import * as React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/AddCircle';

import { EmailValidationRegex } from 'constants.js'


const MultiSelect = ({ onChange, label, arrayItems, defaultValue, isEmailsList, filterFoussierEmail, popinTitle }) => {

    // Hook des éléments sélectionnés
    const [items, setItems] = React.useState(defaultValue !== '' ? [defaultValue] : []);

    // Hook modale de saisie
    const [open, setOpen] = React.useState(false);

    // Hook validation d'une saisie
    const [itemValue, setItemValue] = React.useState({
        item: '',
        errorMessage: ''
    });


    // Première validation
    React.useEffect(() => {
        if (defaultValue !== '') {
            onChange(defaultValue);
        }

        return (
            onChange("")
        )
    }, []);


    // Handler de la sélection des éléments
    const handleChange = (event) => {

        const { target: { value }, } = event;

        // `value` correspond au tableau des éléments sélectionnés dans la liste
        setItems(value);

        // Enregistrement des éléments
        handleOnChange(value);
    };


    // Rendu des éléments dans le `select`
    const getWordingMenuItem = (item) => {

        if (typeof item === 'object') {

            let nom = '';
            let prenom = '';

            if (item.nom) {
                nom = item.nom
            }
            if (item.prenom) {
                prenom = item.prenom
            }

            if (nom !== '' || prenom !== '') {
                return `${nom} ${prenom} / ${item.email}`;
            }
            else {
                return `${item.email}`;
            }
        }

        if (typeof item === 'string') {
            return item;
        }
    }


    // Validité d'un élément
    const checkValidite = (event) => {

        const { target: { value }, } = event;

        if (isEmailsList) {
            handleEmailValide(value);
        }
    }


    // Handler de validité d'un email
    const handleEmailValide = (value) => {

        let errorMessage = '';

        let valueTrim = value.trim();

        if (valueTrim) {
            let result = EmailValidationRegex.test(valueTrim);
            if (!result) {
                errorMessage = "Adresse email non valide";

            } else if (filterFoussierEmail) {

                let isFoussierEmail = valueTrim.includes("@foussier.fr");
                if (isFoussierEmail) {
                    errorMessage = "Adresse email non valide, les adresses Foussier ne sont pas autorisées";
                }
            }
        }

        setItemValue({
            item: valueTrim,
            errorMessage: errorMessage
        });
    }


    // Handler de la fermeture de la dialogue d'ajout
    const handleCloseDialog = () => {
        setOpen(false);
        setItemValue({
            item: '',
            errorMessage: ''
        });
    }


    // Handler d'ajout d'un élément
    const handleAddEmail = () => {
        const value = itemValue.item.trim();
        const exist = items.find(x => x === value);

        if (!exist) {
            const newArray = [...items, value];

            setItems(newArray);

            setOpen(false);
            setItemValue({
                item: '',
                errorMessage: ''
            });

            // Enregistrement des éléments
            handleOnChange(newArray);

        } else {
            setItemValue({
                ...itemValue,
                errorMessage: 'Cette adresse a déjà été ajouté dans la liste'
            });
        }

    }


    // Handler de suppression d'un élément
    const handleDeleteItem = (email) => {
        const newarray = items.filter(x => x !== email);

        setItems(newarray);

        // Enregistrement des éléments
        handleOnChange(newarray);
    }

    // Handler d'enregistrement des éléments de liste
    const handleOnChange = (arrayItems) => {
        const itemsList = arrayItems.map(x => x.trim()).filter(x => x).join(';');

        onChange(itemsList);
    }

    return (
        <>
            <fieldset style={{ borderRadius: '8px', borderColor: 'black', width: 700 }}>
                <legend>
                    <span style={{ paddingRight: '20px' }}>{label}</span>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => setOpen(true)}
                        startIcon={<AddIcon />}
                    >
                        Ajouter
                    </Button>
                </legend>

                <FormControl sx={{ m: 1, width: 700 }}>
                    <Select
                        labelId="multi-chip-label"
                        id="multi-chip"
                        multiple
                        value={items}
                        onChange={handleChange}
                        renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {selected.map((value) => (
                                    <Chip
                                        key={value}
                                        label={value}
                                        onDelete={() => handleDeleteItem(value)}
                                        onMouseDown={(event) => { event.stopPropagation(); }}
                                    />
                                ))}
                            </Box>
                        )}
                    >
                        {arrayItems.map((elem) => (
                            <MenuItem
                                key={`contact-${elem.id}`}
                                value={elem.email}
                            >
                                <Checkbox checked={items.findIndex(x => x === elem.email) > -1} />
                                {getWordingMenuItem(elem)}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </fieldset >


            <Dialog
                fullWidth
                open={open}
            >
                <DialogTitle>{popinTitle}</DialogTitle>

                <DialogContent>
                    <TextField
                        id="ajout"
                        name="ajout"
                        label="Nouveau"
                        value={itemValue.item}
                        onChange={(e) => checkValidite(e)}
                        autoFocus
                        fullWidth
                        sx={{ mt: 2 }}
                        helperText={itemValue.errorMessage}
                        error={!!itemValue.errorMessage}
                    />
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => handleCloseDialog()}
                        variant="contained"
                        color="primary"
                        sx={{ mr: 3 }}
                    >
                        Annuler
                    </Button>

                    <Button
                        disabled={!!itemValue.errorMessage || itemValue.item === ''}
                        variant="contained"
                        onClick={() => handleAddEmail()}
                        color="secondary"
                        sx={{ m: 2 }}

                    >
                        Ajouter
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

MultiSelect.defaultProps = {
    popinTitle: "Ajouter dans la liste",
    isEmailsList: false,
    filterFoussierEmail: false
}

export default MultiSelect;
